import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b60ee18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "no-mb",
  style: {"line-height":"2"}
}


import { HighlightOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyDetailsRow',
  props: {
  label: String,
  content: String,
  showChangeBtn: Boolean
},
  emits: ['buttonClicked'],
  setup(__props, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "survey-detail-row no-mb" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 8}
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(props.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _createTextVNode(_toDisplayString(props.content) + " ", 1),
            (__props.showChangeBtn)
              ? (_openBlock(), _createBlock(_unref(HighlightOutlined), {
                  key: 0,
                  style: { marginLeft: '8px', color: '#f38929', cursor: 'pointer' },
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('buttonClicked')))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})